<template>
  <div class="picture-drawer" ref="pictureDrawer">
    <canvas
      id="backgroundCanvas"
      ref="backgroundCanvas"
      :style="{ position: 'absolute', top: 0, left: 0, zIndex: 0 }"
    ></canvas>
    <canvas
      id="canvas"
      :style="{ position: 'absolute', top: 0, left: 0, zIndex: 1 }"
      @pointerdown="engage"
      @pointermove="putPoint"
      @pointerup="disengage"
      @pointerleave="disengage"
    >
      Sorry, your browser doesn't support the app.
    </canvas>
    <div class="toolbar-container">
      <div id="toolbar">
        <img
          v-if="stylusType == 'touch'"
          src="@/assets/stylus-pen.svg"
          :class="['tool', 'img', 'pen', stylus == 'write' ? 'selected' : '']"
          @click="stylus = 'write'"
        />
        <img
          v-if="stylusType == 'pen'"
          src="@/assets/stylus-pencil.svg"
          :class="['tool', 'img', 'pen', stylus == 'write' ? 'selected' : '']"
          @click="stylus = 'write'"
        />
        <img
          src="@/assets/stylus-highlighter.svg"
          :class="[
            'tool',
            'img',
            'highlighter',
            stylus == 'highlighter' ? 'selected' : '',
          ]"
          @click="stylus = 'highlighter'"
        />
        <img
          src="@/assets/ink-eraser.svg"
          :class="[
            'tool',
            'img',
            'eraser',
            stylus == 'eraser' ? 'selected' : '',
          ]"
          @click="stylus = 'eraser'"
        />
        <div class="toolbar-separator"></div>
        <div class="tool imglabel size">
          <img
            src="@/assets/pen-size-3.svg"
            @click="toolbarRadiusPanel = true"
          />
          <div @click="toolbarRadiusPanel = true">{{ radius }}</div>
          <div v-if="toolbarRadiusPanel" class="toolbarRadiusPanel">
            <div class="panel-title">
              {{ $anm22.strLang(lang, "Size", "Dimensione") }}
            </div>
            <div class="panel-options">
              <img
                src="@/assets/pen-size-1.svg"
                @click="
                  setRadius(1);
                  toolbarRadiusPanel = false;
                "
                :class="this.radius == 1 ? 'selected' : ''"
              />
              <img
                src="@/assets/pen-size-2.svg"
                @click="
                  setRadius(2);
                  toolbarRadiusPanel = false;
                "
                :class="this.radius == 2 ? 'selected' : ''"
              />
              <img
                src="@/assets/pen-size-3.svg"
                @click="
                  setRadius(3);
                  toolbarRadiusPanel = false;
                "
                :class="this.radius == 3 ? 'selected' : ''"
              />
              <img
                src="@/assets/pen-size-4.svg"
                @click="
                  setRadius(5);
                  toolbarRadiusPanel = false;
                "
                :class="this.radius == 5 ? 'selected' : ''"
              />
              <img
                src="@/assets/pen-size-5.svg"
                @click="
                  setRadius(8);
                  toolbarRadiusPanel = false;
                "
                :class="this.radius == 8 ? 'selected' : ''"
              />
            </div>
          </div>
        </div>
        <div class="toolbar-separator"></div>
        <div class="tool imglabel color">
          <div
            class="swatch"
            :style="{ backgroundColor: color }"
            @click="toolbarColorPanel = true"
          ></div>
          <div v-if="toolbarColorPanel" class="toolbarColorPanel">
            <div class="panel-title">
              {{ $anm22.strLang(lang, "Color", "Colore") }}
            </div>
            <div class="panel-options">
              <div
                v-for="(colorItem, key) in colors"
                :key="'color-' + key"
                :class="['swatch', color == colorItem ? 'active' : '']"
                :style="{ backgroundColor: colorItem }"
                @click="setSwatch"
              ></div>
            </div>
          </div>
        </div>
        <div class="toolbar-separator"></div>
        <div id="save" @click="saveImage" class="save">
          {{ $anm22.strLang(lang, "Save", "Salva") }}
        </div>
      </div>
    </div>
    <!--<div
      ref="zoomContainer"
      class="zoomable"
      @touchstart="onTouchStart"
      @touchmove="onTouchMove"
      @wheel.prevent="onWheelZoom"
      @mousedown="onDragStart"
      @mousemove="onDragMove"
      @mouseup="onDragEnd"
      @mouseleave="onDragEnd"
      @touchstart.passive="onDragStartTouch"
      @touchmove.passive="onDragMoveTouch"
      @touchend="onDragEnd"
    >
      <img
        ref="zoomImg"
        :style="imageStyle"
        :src="$anm22.getImagePath(picToShow, false)"
        @load="calculateMinScale"
      />
    </div>-->
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  props: {
    picToShow: [String],
    projectId: [Number],
  },
  data() {
    return {
      scale: 1,
      lastScale: 1,
      startDistance: 0,
      isDragging: false,
      dragStartX: 0,
      dragStartY: 0,
      translateX: 0,
      translateY: 0,

      canvas: null,
      context: null,
      backgroundCanvas: null,
      backgroundContext: null,
      radius: 1,
      radiusSize: 1,
      dragging: false,

      colors: [
        "black",
        "grey",
        "white",
        "red",
        "orange",
        "yellow",
        "green",
        "blue",
        "indigo",
        "violet",
      ],
      color: "red",

      minRad: 1,
      maxRad: 100,
      interval: 2,
      stylus: "write",
      stylusType: "touch",

      toolbarRadiusPanel: false,
      toolbarColorPanel: false,
    };
  },
  computed: {
    ...mapState({
      lang: (state) => state.lang,
    }),
    imageStyle() {
      return {
        width: "100%",
        height: "100%",
        objectFit: "contain",
        objectPosition: "center",
        cursor: this.scale > this.minScale ? "grab" : "default",
        transition: this.isDragging ? "none" : "transform 0.2s ease-out",
        transform: `scale(${this.scale}) translate(${this.translateX}px, ${
          this.translateY
        }px)`,
      };
    },
  },
  methods: {
    calculateMinScale() {
      this.minScale = 1;
      this.scale = this.minScale;
    },
    getDistance(touches) {
      const [touch1, touch2] = touches;
      return Math.sqrt(
        Math.pow(touch2.pageX - touch1.pageX, 2) +
          Math.pow(touch2.pageY - touch1.pageY, 2)
      );
    },
    onTouchStart(event) {
      if (event.touches.length === 2) {
        this.startDistance = this.getDistance(event.touches);
        this.lastScale = this.scale;
      }
    },
    onTouchMove(event) {
      if (event.touches.length === 2) {
        const newDistance = this.getDistance(event.touches);
        const scaleChange = newDistance / this.startDistance;
        this.scale = Math.max(
          this.minScale,
          Math.min(3, this.lastScale * scaleChange)
        );
      }
    },
    onTouchEnd() {
      if (this.scale < this.minScale) {
        this.scale = this.minScale;
      }
    },
    onWheelZoom(event) {
      if (event.ctrlKey) {
        // Il browser usa Ctrl+Scroll per lo zoom
        event.preventDefault();
        const delta = event.deltaY > 0 ? -0.1 : 0.1;
        this.scale = Math.max(this.minScale, Math.min(3, this.scale + delta));

        if (this.scale === this.minScale) {
          this.translateX = 0;
          this.translateY = 0;
        }
      }
    },
    onDragStart(event) {
      if (this.scale > this.minScale) {
        // Abilita drag solo se l'immagine è ingrandita
        this.isDragging = true;
        this.dragStartX = event.clientX * (1 / this.scale) - this.translateX;
        this.dragStartY = event.clientY * (1 / this.scale) - this.translateY;
        event.preventDefault(); // Evita selezione indesiderata
      }
    },
    onDragMove(event) {
      if (this.isDragging) {
        this.translateX = event.clientX * (1 / this.scale) - this.dragStartX;
        this.translateY = event.clientY * (1 / this.scale) - this.dragStartY;
      }
    },
    onDragEnd() {
      if (this.scale < this.minScale) {
        this.scale = this.minScale;
      }
      this.isDragging = false;
    },
    onDragStartTouch(event) {
      if (this.scale > this.minScale && event.touches.length === 1) {
        this.isDragging = true;
        this.touchStartX =
          event.touches[0].clientX * (1 / this.scale) - this.translateX;
        this.touchStartY =
          event.touches[0].clientY * (1 / this.scale) - this.translateY;
        event.preventDefault();
      }
    },
    onDragMoveTouch(event) {
      if (this.isDragging && event.touches.length === 1) {
        this.translateX =
          event.touches[0].clientX * (1 / this.scale) - this.touchStartX;
        this.translateY =
          event.touches[0].clientY * (1 / this.scale) - this.touchStartY;
      }
    },
    // COLOR LIB
    setColor(newColor) {
      this.color = newColor;
      this.context.fillStyle = this.color;
      this.context.strokeStyle = this.color;
    },
    setSwatch(e) {
      var swatch = e.target;
      this.setColor(swatch.style.backgroundColor);
      this.toolbarColorPanel = false;
    },
    // RADIUS LIB
    setRadius(newRadius) {
      if (newRadius < this.minRad) newRadius = this.minRad;
      else if (newRadius > this.maxRad) newRadius = this.maxRad;
      this.radius = newRadius;
      this.context.lineWidth = this.radius * 2;
    },
    increaseRadius() {
      this.setRadius(this.radius + this.interval);
    },
    decreaseRadius() {
      this.setRadius(this.radius - this.interval);
    },
    saveImage() {
      const finalCanvas = document.createElement("canvas");
      finalCanvas.width = this.backgroundCanvas.width;
      finalCanvas.height = this.backgroundCanvas.height;
      const finalCtx = finalCanvas.getContext("2d");

      finalCtx.drawImage(this.backgroundCanvas, 0, 0);
      finalCtx.drawImage(this.canvas, 0, 0);

      finalCanvas.toBlob((blob) => {
        if (!blob) {
          console.error("Errore nella conversione del canvas in Blob.");
          return;
        }

        let formData = new FormData();
        formData.append("file", blob, "canvas-image.png");

        fetch(
          process.env.VUE_APP_BACK_DOMAIN +
            "/app/tasks/spa/controller/vircos/graphics-image?idWorldProject=" +
            this.projectId,
          {
            method: "POST",
            body: formData,
            credentials: "include",
          }
        )
          .then((response) => response.json())
          .then((data) => this.$emit("addImage", data))
          .then(() => this.$emit("closeDrawer"))
          .catch((error) =>
            console.error("Errore nel salvataggio dell'immagine:", error)
          );
      }, "image/png");
    },
    // MAIN DRAWER
    drawerInit() {
      this.backgroundCanvas = this.$refs.backgroundCanvas;
      this.backgroundContext = this.backgroundCanvas.getContext("2d");

      this.canvas = document.getElementById("canvas");
      this.context = canvas.getContext("2d");

      this.backgroundCanvas.width = this.$refs.pictureDrawer.clientWidth;
      this.backgroundCanvas.height = this.$refs.pictureDrawer.clientHeight;

      this.canvas.width = this.$refs.pictureDrawer.clientWidth;
      this.canvas.height = this.$refs.pictureDrawer.clientHeight;

      this.context.lineWidth = this.radius * 2;

      this.setColor(this.color);

      // Background
      const img = new Image();
      img.crossOrigin = "anonymous";
      img.src =
        process.env.VUE_APP_BACK_DOMAIN +
        "/app/tasks/spa/controller/vircos/drawer-image-proxy?url=" +
        this.picToShow;

      img.onload = () => {
        // Get image size
        let canvasImageSize = this.getFullSizeAxis(
          img.naturalWidth,
          img.naturalHeight,
          this.canvas.width,
          this.canvas.height
        );

        this.backgroundContext.drawImage(
          img,
          (this.canvas.width - canvasImageSize.width) / 2,
          (this.canvas.height - canvasImageSize.height) / 2,
          canvasImageSize.width,
          canvasImageSize.height
        );
      };
    },
    getFullSizeAxis(elementWidth, elementHeight, areaWidth, areaHeight) {
      const elementRatio = elementWidth / elementHeight;
      const areaRatio = areaWidth / areaHeight;

      let finalWidth, finalHeight;

      if (elementRatio > areaRatio) {
        // L'immagine è più larga rispetto all'area: uso tutta la larghezza
        finalWidth = areaWidth;
        finalHeight = areaWidth / elementRatio;
      } else {
        // L'immagine è più alta rispetto all'area: uso tutta l'altezza
        finalHeight = areaHeight;
        finalWidth = areaHeight * elementRatio;
      }

      return {
        width: finalWidth,
        height: finalHeight,
      };
    },
    clearCanvas(canvas) {
      canvas.width = canvas.width;
    },
    onResize() {
      /*
      var image = context.getImageData(
        0,
        0,
        this.canvas.width,
        this.canvas.height
      );
      this.canvas.width = window.innerWidth;
      this.canvas.height = window.innerHeight;
      this.context.putImageData(image, 0, 0);
      this.context.fillStyle = this.color;
      this.context.strokeStyle = this.color;
      this.setRadius(radius);
      */
    },

    putPoint(e) {
      e.preventDefault();
      if (this.dragging) {
        // Detect pen events and rules
        let isPen = false;
        if (e.pointerType === "pen") {
          this.stylusType = "pen";
          isPen = true;
        }
        if (this.stylusType == "pen" && !isPen) {
          console.log("Pen required");
          return;
        }

        const offsets = this.canvas.getBoundingClientRect();
        const x = e.clientX - offsets.left;
        const y = e.clientY - offsets.top;

        if (this.stylus == "eraser") {
          this.context.globalAlpha = 1.0;
          this.context.globalCompositeOperation = "destination-out";
          this.context.beginPath();
          this.context.arc(x, y, this.radius, 0, Math.PI * 2, false);
          this.context.fill();
          this.context.globalCompositeOperation = "source-over";
        } else {
          if (this.stylus === "highlighter") {
            this.context.globalAlpha = 0.03;
          } else {
            this.context.globalAlpha = 1.0;
          }
          this.context.globalCompositeOperation = "source-over";
          this.context.lineTo(x, y);
          this.context.stroke();
          this.context.beginPath();
          this.context.arc(x, y, this.radius, 0, Math.PI * 2);
          this.context.fill();
          this.context.beginPath();
          this.context.moveTo(x, y);
        }
      }
    },
    getMousePosition(event) {
      const rect = this.canvas.getBoundingClientRect(); // Ottieni le coordinate del canvas

      const x = event.clientX - rect.left; // Calcola la posizione relativa
      const y = event.clientY - rect.top;

      return { x, y };
    },

    engage(e) {
      // Detect pen events and rules
      let isPen = false;
      if (e.pointerType === "pen") {
        this.stylusType = "pen";
        isPen = true;
      }
      if (this.stylusType == "pen" && !isPen) {
        console.log("Pen required");
        return;
      }

      this.dragging = true;
      this.putPoint(e);
    },
    disengage() {
      this.dragging = false;
      this.context.beginPath();
    },

    getTouchPos(touchEvent) {
      const offsets = this.canvas.getBoundingClientRect();
      return {
        x: touchEvent.touches[0].clientX - offsets.left,
        y: touchEvent.touches[0].clientY - offsets.top,
      };
    },

    touchPutPoint(e) {
      e.preventDefault();
      if (this.dragging) {
        const touchPosition = this.getTouchPos(e);
        const x = touchPosition.x;
        const y = touchPosition.y;

        if (this.stylus == "eraser") {
          this.context.globalAlpha = 1.0;
          this.context.globalCompositeOperation = "destination-out";
          this.context.beginPath();
          this.context.arc(x, y, this.radius, 0, Math.PI * 2, false);
          this.context.fill();
          this.context.globalCompositeOperation = "source-over";
        } else {
          if (this.stylus === "highlighter") {
            this.context.globalAlpha = 0.03;
          } else {
            this.context.globalAlpha = 1.0;
          }
          this.context.globalCompositeOperation = "source-over";
          this.context.lineTo(x, y);
          this.context.stroke();
          this.context.beginPath();
          this.context.arc(x, y, this.radius, 0, Math.PI * 2);
          this.context.fill();
          this.context.beginPath();
          this.context.moveTo(x, y);
        }
      }
    },

    touchEngage(e) {
      this.dragging = true;
      // Detect pen
      let isPen = false;
      if (e.pointerType === "pen") {
        this.stylusType = "pen";
        isPen = true;
      }
      if (this.stylusType != "pen" || isPen) {
        this.touchPutPoint(e);
      }
    },
    touchDisengage() {
      this.disengage();
    },
  },
  mounted() {
    this.drawerInit();
  },
};
</script>

<style lang="scss" scoped>
.picture-drawer {
  width: 100%;
  height: 100%;
}
.zoomable {
  touch-action: none;
  overflow: hidden;
  width: 100%;
  height: 100%;
}

img {
  border: 0;
}

/* Canvas */
#canvas {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-position: center center;
  background-size: contain;
  background-repeat: no-repeat;
  touch-action: none;
}

* {
  box-sizing: border-box;
  user-select: none;
}
.toolbar-container {
  padding: 10px;
  height: 60px;
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  z-index: 10;

  #toolbar {
    width: 100%;
    height: 40px;
    background-color: #eee;
    background-color: #eeeeeeaa;
    border-radius: 20px;
    padding: 0 10px;
    color: #333;
    display: flex;
    align-items: center;

    .toolbar-separator {
      border-left: 1px solid #666;
      margin: 0 5px;
      height: 20px;
    }

    .tool {
      bottom: 0;
      height: 30px;
      margin: 5px;
      cursor: pointer;

      &.img {
        width: 30px;
        opacity: 0.3;

        &.selected,
        &:hover {
          opacity: 0.6;
        }
      }

      &.imglabel {
        display: flex;
        align-items: center;
        position: relative;

        img {
          height: 30px;
          width: 30px;
          margin-right: 4px;
        }
        div {
          font-size: 16px;
        }
      }
    }

    .save {
      height: 30px;
      padding: 8px;
      background-color: #eee;
      line-height: 1;
      cursor: pointer;
      border-radius: 6px;
      border: 1px solid #ccc;

      &:hover {
        background-color: #ddd;
      }
    }

    .toolbarRadiusPanel,
    .toolbarColorPanel {
      position: absolute;
      left: 0;
      top: -80px;
      background-color: #eee;
      border-radius: 6px;
      padding: 8px 0px;
      cursor: default;

      .panel-title {
        padding: 0 12px;
      }
      .panel-options {
        margin-top: 8px;
        display: flex;
        padding: 0 3px;

        img {
          width: 30px;
          height: 30px;
          margin: 0 5px;

          &.selected,
          &:hover {
            cursor: pointer;
            background-color: #ddd;
            border-radius: 10px;
          }
        }
      }
    }

    .toolbarColorPanel {
      left: -200px;
    }

    #colors {
      display: flex;
      overflow-x: auto;
      overflow-y: hidden;
      max-width: calc(100% - 202px);
      white-space: nowrap;
      align-items: center;
    }
    .swatch {
      width: 24px;
      min-width: 24px;
      height: 24px;
      border-radius: 15px;
      margin: 0 5px;
      background-color: cyan;
      cursor: pointer;

      &:hover,
      &.active {
        width: 28px;
        height: 28px;
      }
    }
  }
}

.radcontrol {
  width: 30px;
  height: 30px;
  background-color: #eee;
  display: inline-block;
  text-align: center;
  padding: 5px;
  cursor: pointer;
}

#rad {
  float: left;
}
</style>
